// Client-side Sentry init for the Next.js web app (@sentry/nextjs v9, Next 16).
// The actual init + helpers live in lib/analytics/sentry.web.ts (shared with the rest
// of the app); importing it here registers it on the official client-instrumentation
// path so it runs as early as possible. Same module instance as the app's
// `@lib/analytics/sentry` imports, so Sentry.init runs exactly once.
;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[]}";import './lib/analytics/sentry.web';
